import { configureStore, combineReducers } from '@reduxjs/toolkit';
import modelSurfaceSlice from './slices/modelSurfaceSlice';
import logger from 'redux-logger';

const rootReducer = combineReducers({
  modelSurfaceSlice,
});

export type RootState = ReturnType<typeof rootReducer>;

// Add logger in development
const middleware =
  process.env.NODE_ENV === 'development'
    ? (getDefaultMiddleware) => getDefaultMiddleware().concat(logger)
    : (getDefaultMiddleware) => getDefaultMiddleware();

export default configureStore({
  reducer: rootReducer,
  middleware: middleware,
});
